var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('lottie',{staticClass:"icon",attrs:{"height":100,"width":100,"options":_vm.options},on:{"animCreated":_vm.initAnim},nativeOn:{"click":function($event){return _vm.changeFrame.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }